<div class="card card-custom">
  <div class="card-header">
    <div class="card-title">
      <img
        src="./assets/media/svg/icons/General/process-nav.svg"
        alt="Process Navigator Icon"
        width="30px"
        class="mr-4"
      />
      <h3 class="card-label">Knostos Process Navigator</h3>
    </div>
    <div class="card-toolbar">
      <button type="button" class="btn btn-sm btn-outline-secondary" (click)="close($event)">
        <i class="flaticon2-cross icon-sm p-0"></i>
      </button>
    </div>
  </div>
  <div style="height: 400px" class="card-body d-flex flex-column">
    <div style="font-size: 15px" class="font-weight-bold">
      For: <span class="text-muted">{{ getName() | titlecase }}</span>
    </div>
    <div class="flex-grow-1 d-flex align-items-center justify-content-around">
      <div *ngIf="!(data.resources$ | async)?.length" class="font-weight-bold">
        No Resources Available!
      </div>
      <div
        *ngFor="let resource of data.resources$ | async"
        style="height: 160px; width: 160px"
        class="rounded-circle cursor-pointer d-flex flex-center"
        [ngClass]="
          resource.type === ResourceType.HTML
            ? 'bg-light-success'
            : resource.type === ResourceType.PDF
            ? 'bg-light-danger'
            : 'bg-light-primary'
        "
        (click)="openResource($event, resource)"
      >
        <img
          [src]="
            resource.type === ResourceType.HTML
              ? './assets/media/svg/files/html.svg'
              : resource.type === ResourceType.PDF
              ? './assets/media/svg/files/pdf.svg'
              : './assets/media/svg/files/mp4.svg'
          "
          alt="Filetype Icon"
          width="100px"
        />
      </div>
    </div>
  </div>
</div>
